module.exports = __webpack_public_path__ + "img/spread.9189ade3.jpg";